import { useEffect, useState } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

const heroSlides = [
  { image: '/images/hero-originals/capelli.webp', title: 'Nashi Argan Capelli' },
  { image: '/images/hero-originals/spring-collection.jpg', title: 'Spring Collection' },
  { image: '/images/hero-originals/speedy-beauty.jpg', title: 'Speedy Beauty' },
  { image: '/images/hero-originals/corpo.webp', title: 'Corpo' },
  { image: '/images/hero-originals/viso.jpg', title: 'Viso' },
  { image: '/images/hero-originals/fragranze.webp', title: 'Fragranze' },
  { image: '/images/hero-originals/solari.webp', title: 'Solari' },
]

export function Hero() {
  const [activeIdx, setActiveIdx] = useState(0)
  const { scrollY } = useScroll()
  const yImage = useTransform(scrollY, [0, 800], [0, 80])

  // Auto-advance slides every 6s
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIdx((prev) => (prev + 1) % heroSlides.length)
    }, 6000)
    return () => clearInterval(interval)
  }, [])

  const slide = heroSlides[activeIdx]

  return (
    <section aria-label="Featured collection">
      {/* Image stage */}
      <div className="relative w-full overflow-hidden bg-bruno" style={{ height: 'clamp(560px, 85vh, 920px)' }}>
        <motion.div style={{ y: yImage }} className="absolute inset-0">
          {heroSlides.map((s, idx) => (
            <div
              key={s.image}
              className={`absolute inset-0 transition-opacity duration-1000 ease-out ${
                idx === activeIdx ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${s.image})` }}
              />
            </div>
          ))}
        </motion.div>

        {/* Bottom gradient for text readability */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(180deg, rgba(20,15,12,0.10) 0%, rgba(20,15,12,0.25) 60%, rgba(20,15,12,0.65) 100%)',
          }}
        />

        {/* Centered bottom text */}
        <div className="absolute inset-0 flex items-end justify-center pb-16 md:pb-20 z-10">
          <motion.div
            key={`content-${activeIdx}`}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
            className="text-center px-4"
          >
            <h1
              className="font-display text-cream"
              style={{
                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                lineHeight: 1.1,
                letterSpacing: '-0.01em',
                textShadow: '0 2px 20px rgba(20,15,12,0.6)',
              }}
            >
              {slide.title}
            </h1>
          </motion.div>
        </div>
      </div>

      {/* Collection tabs */}
      <div className="bg-cream border-b border-argan/20">
        <div className="nashi-container">
          <div className="flex items-center justify-center gap-2 md:gap-3 py-4 md:py-5 overflow-x-auto scrollbar-hide">
            {heroSlides.map((s, idx) => (
              <button
                key={s.title}
                type="button"
                onClick={() => setActiveIdx(idx)}
                className={`shrink-0 px-4 md:px-5 py-2 text-[10px] md:text-[11px] font-medium uppercase tracking-[0.18em] transition-all duration-300 border ${
                  idx === activeIdx
                    ? 'bg-bruno text-cream border-bruno'
                    : 'bg-transparent text-bruno-soft border-argan/40 hover:border-bruno hover:text-bruno'
                }`}
              >
                {s.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
